import { useMentionPlugin } from "~/sharedComponents/advancedEditor/hooks/useMentionPlugin";
import { MentionPlugin } from "~/sharedComponents/advancedEditor/types/types";
import { MentionComponentProps, createMentionComponent } from "../components/MentionComponent";
import { MentionSuggestionsWrapper } from "../components/MentionSuggestionsWrapper";
import { MessageOwnerState } from "../types";

export const useMentionPluginForMessageBoard = (props: MessageOwnerState) => {
    const mention = useMentionPlugin<MentionPlugin & MessageOwnerState, MentionComponentProps>({
        mentionComponent: createMentionComponent(props),
        mentionListProps: props,
        MentionList: MentionSuggestionsWrapper,
    });

    return mention;
};
